import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'documentCheckSupersedePipe'
})
export class DocumentCheckSupersedePipe implements PipeTransform {

  transform(dataItem: any, canSupersede?: boolean): any {
    if (canSupersede && dataItem.trans_type == 'Approved') {
      return true
    }
    else {
      return false;
    }
  }

}
